import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SolutionHero from '@/components/feature/solution/SolutionHero';
import SolutionChallenge from '@/components/feature/solution/SolutionChallenge';
import SolutionValues from '@/components/feature/solution/SolutionValues';
import SolutionServiceFlow from '@/components/feature/solution/SolutionServiceFlow';
import SolutionScenarios from '@/components/feature/solution/SolutionScenarios';
import SolutionMetrics from '@/components/feature/solution/SolutionMetrics';
import FloatingConsult from '@/components/feature/solution/FloatingConsult';
import {
  hero,
  challenge,
  values,
  serviceFlow,
  scenarios,
  metrics,
} from '@/mocks/smart-catering';

export default function SmartCatering() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="智慧餐饮解决方案｜门店数字化与厨房协同｜华辉数智"
        description="华辉数智智慧餐饮解决方案，通过数字化工具优化点餐、出餐、库存、营销与经营决策，连接门店、厨房、供应链与会员，让餐饮服务更高效、更懂顾客。"
        keywords="智慧餐饮,扫码点餐,厨房协同,会员运营,餐饮数字化"
        path="/solutions/smart-catering"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '智慧餐饮解决方案',
          description:
            '华辉数智智慧餐饮解决方案，通过数字化工具优化点餐、出餐、库存、营销与经营决策，让餐饮服务更高效。',
        }}
      />

      <SolutionHero data={hero} accentKey="green" />
      <Breadcrumb items={[{ label: '产品与解决方案' }, { label: '解决方案', href: '/solutions' }, { label: '智慧餐饮' }]} />

      <main>
        <SolutionChallenge
          eyebrow={challenge.eyebrow}
          title={challenge.title}
          subtitle={challenge.subtitle}
          items={challenge.items}
          variant="grid"
          accentKey="green"
        />
        <SolutionValues
          eyebrow={values.eyebrow}
          title={values.title}
          subtitle={values.subtitle}
          items={values.items}
          accentKey="green"
        />
        <SolutionServiceFlow
          eyebrow={serviceFlow.eyebrow}
          title={serviceFlow.title}
          subtitle={serviceFlow.subtitle}
          endpoints={serviceFlow.endpoints}
          flow={serviceFlow.flow}
          accentKey="green"
        />
        <SolutionScenarios
          eyebrow={scenarios.eyebrow}
          title={scenarios.title}
          scenarios={scenarios.scenarios}
          variant="tabs"
          accentKey="green"
        />
        <SolutionMetrics
          eyebrow={metrics.eyebrow}
          title={metrics.title}
          items={metrics.items}
          dashboard={metrics.dashboard}
          accentKey="green"
        />
      </main>

      <Footer />
      <FloatingConsult accentKey="green" />
    </div>
  );
}